import { mediaQueries } from '@centivo/react-components'
import styled from 'styled-components'

export const Nav = styled.nav`
  position: sticky;
  top: 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 2rem 1rem 1.5rem 1.25rem;
  z-index: 10;
  width: 100%;
  max-width: 1440px;
  margin: auto;

  & > a {
    align-items: center;
    display: flex;
    height: 2rem;

    @media ${mediaQueries.desktop} {
      align-items: flex-end;
      height: 3.25rem;
    }
  }

  @media ${mediaQueries.desktop} {
    padding: 1.5rem 2.5rem 1.5rem;
  }
`
